import type { SVGProps } from "react";
export interface AvocadoIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AvocadoIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AvocadoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.251.875c1.285.018 2.428.523 3.388 1.484l.339.37c.74.879 1.127 1.893 1.142 3.017.017 1.241-.421 2.513-1.132 3.783-.591 1.057-1.23 2.158-1.998 4.46-.773 2.317-1.192 4.29-3.36 6.458-3.452 3.451-9.149 3.563-12.742.326l-.34-.323c-3.563-3.564-3.563-9.522 0-13.086l.405-.386c2.011-1.835 3.88-2.248 6.052-2.973 2.303-.767 3.404-1.408 4.46-2l.477-.253c1.112-.56 2.222-.892 3.309-.877m-.032 2.25c-.7-.01-1.572.24-2.655.845-1.099.615-2.345 1.336-4.847 2.17-2.331.777-3.69 1.066-5.261 2.51l-.317.305c-2.685 2.685-2.685 7.22 0 9.904l.257.243c2.708 2.438 7.041 2.355 9.643-.246 1.712-1.713 1.986-3.092 2.815-5.578.834-2.502 1.554-3.748 2.17-4.847.606-1.083.855-1.956.846-2.655-.009-.655-.244-1.249-.822-1.826-.577-.578-1.173-.816-1.83-.825Z"
      />
      <path
        fill={color}
        d="M13.205 13.67a2.875 2.875 0 1 0-5.75 0 2.875 2.875 0 0 0 5.75 0m2.25 0a5.124 5.124 0 0 1-10.25 0 5.126 5.126 0 0 1 10.25 0"
      />
    </svg>
  );
}
